import React, { useEffect, useState } from "react";
import "./styles/App.css";
import twitterLogo from "./assets/twitter-logo.svg";
import { ethers } from "ethers";
import DomainService from "../../utils/DomainServiceUpdated.json";
import polygonLogo from "./assets/polygonlogo.png";
import ethLogo from "./assets/ethlogo.png";
import { networks } from "../../utils/networks";
import Navbar from "../navbar/navbar";
// Constants

const TWITTER_HANDLE = "_buildspace";
const TWITTER_LINK = `https://twitter.com/${TWITTER_HANDLE}`;

const tld = ".coder";
const CONTRACT_ADDRESS = "0x798DAF5bA87b4DC904Aeb3e15EEbB4043eC27FF4";

const App = () => {
	const [account, setAccount] = useState("");
	const [loading, setLoading] = useState(false);
	const [editing, setEditing] = useState(false);
	const [network, setNetwork] = useState("");
	const [domain, setDomain] = useState("");
	const [bio, setBio] = useState("");
	const [linkedIn, setLinkedIn] = useState("");
	const [github, setGithub] = useState("");
	const [twitter, setTwitter] = useState("");
	const [website, setWebsite] = useState("");
	const [mints, setMints] = useState([]);
	const [email, setEmail] = useState("");
	const [leetcode, setLeetcode] = useState("");
	function onChangeTextFeild(event, name) {
		switch (name) {
			case "leetcode":
				setLeetcode(event.target.value);
				break;

			case "email":
				setEmail(event.target.value);
				break;

			case "website":
				setWebsite(event.target.value);
				break;

			case "twitter":
				setTwitter(event.target.value);
				break;

			case "github":
				setGithub(event.target.value);
				break;

			case "linkedIn":
				setLinkedIn(event.target.value);
				break;

			case "bio":
				setBio(event.target.value);
				break;

			// case "domain":
			// 	setDomain(event.target.value);
			// 	break;
			default:
				break;

			// setProjectName(event.target.value);
		}
	}
	const fetchMints = async () => {
		try {
			const { ethereum } = window;
			if (ethereum) {
				// You know all this
				const provider = new ethers.providers.Web3Provider(ethereum);
				const signer = provider.getSigner();
				const contract = new ethers.Contract(
					CONTRACT_ADDRESS,
					DomainService.abi,
					signer,
				);

				// Get all the domain names from our contract
				const names = await contract.getAllNames();
				console.log(names);
				// For each name, get the record and the address
				const mintRecords = await Promise.all(
					names.map(async (name) => {
						let name1 = name.split(".")[0];
						const mintRecord = await contract.bio(name1);
						const owner = await contract.domains(name1);
						return {
							id: names.indexOf(name),
							name: name1,
							record: mintRecord,
							owner: owner,
						};
					}),
				);

				console.log("MINTS FETCHED ", mintRecords);
				setMints(mintRecords);
			}
		} catch (error) {
			console.log(error);
		}
	};
	const checkIfWalletIsConnected = async () => {
		const { ethereum } = window;

		if (!ethereum) {
			console.log("Make sure you have MetaMask!");
			return;
		} else {
			console.log("We have the ethereum object", ethereum);
		}
		const accounts = await ethereum.request({ method: "eth_accounts" });
		if (accounts.length !== 0) {
			const account = accounts[0];
			console.log("Found an authorized account:", account);
			setAccount(account);
		} else {
			console.log("No authorized account found");
		}
		// This is the new part, we check the user's network chain ID
		const chainId = await ethereum.request({ method: "eth_chainId" });
		setNetwork(networks[chainId]);

		ethereum.on("chainChanged", handleChainChanged);

		// Reload the page when they change networks
		function handleChainChanged(_chainId) {
			window.location.reload();
		}
	};
	const updateDomain = async () => {
		if (
			!bio ||
			!domain ||
			!email ||
			!twitter ||
			!github ||
			!linkedIn ||
			!website ||
			!leetcode
		) {
			return;
		}
		setLoading(true);
		console.log("Updating domain", domain, "with record new records");
		try {
			const { ethereum } = window;
			if (ethereum) {
				const provider = new ethers.providers.Web3Provider(ethereum);
				const signer = provider.getSigner();
				const contract = new ethers.Contract(
					CONTRACT_ADDRESS,
					DomainService.abi,
					signer,
				);

				let tx = await contract.setRecords(
					domain,
					bio,
					linkedIn,
					twitter,
					github,
					website,
					email,
					leetcode,
				);
				await tx.wait();
				console.log("Record set https://mumbai.polygonscan.com/tx/" + tx.hash);

				fetchMints();
				setBio("");
				setLinkedIn("");
				setEmail("");
				setGithub("");
				setLeetcode("");
				setTwitter("");
				setWebsite("");

				setDomain("");
			}
		} catch (error) {
			console.log(error);
		}
		setLoading(false);
	};
	const connectWallet = async () => {
		try {
			const { ethereum } = window;

			if (!ethereum) {
				alert("Get MetaMask -> https://metamask.io/");
				return;
			}

			// Fancy method to request access to account.
			const accounts = await ethereum.request({
				method: "eth_requestAccounts",
			});

			// Boom! This should print out public address once we authorize Metamask.
			console.log("Connected", accounts[0]);
			setAccount(accounts[0]);
		} catch (error) {
			console.log(error);
		}
	};
	const switchNetwork = async () => {
		if (window.ethereum) {
			try {
				// Try to switch to the Mumbai testnet
				await window.ethereum.request({
					method: "wallet_switchEthereumChain",
					params: [{ chainId: "0x13881" }], // Check networks.js for hexadecimal network ids
				});
			} catch (error) {
				// This error code means that the chain we want has not been added to MetaMask
				// In this case we ask the user to add it to their MetaMask
				if (error.code === 4902) {
					try {
						await window.ethereum.request({
							method: "wallet_addEthereumChain",
							params: [
								{
									chainId: "0x13881",
									chainName: "Polygon Mumbai Testnet",
									rpcUrls: ["https://rpc-mumbai.maticvigil.com/"],
									nativeCurrency: {
										name: "Mumbai Matic",
										symbol: "MATIC",
										decimals: 18,
									},
									blockExplorerUrls: ["https://mumbai.polygonscan.com/"],
								},
							],
						});
					} catch (error) {
						console.log(error);
					}
				}
				console.log(error);
			}
		} else {
			// If window.ethereum is not found then MetaMask is not installed
			alert(
				"MetaMask is not installed. Please install it to use this app: https://metamask.io/download.html",
			);
		}
	};
	const renderInputForm = () => {
		if (network !== "Polygon Mumbai Testnet") {
			return (
				<div className="connect-wallet-container">
					<p>Please connect to the Polygon Mumbai Testnet</p>
					<button className="cta-button mint-button" onClick={switchNetwork}>
						Click here to switch
					</button>
				</div>
			);
		}
		return (
			<div className="form-container">
				<div className="first-row">
					<input
						type="text"
						value={domain}
						placeholder="domain"
						onChange={(e) => setDomain(e.target.value)}
					/>
					<p className="tld"> {tld} </p>
				</div>

				<input
					type="text"
					value={bio}
					placeholder="Enter your Bio"
					onChange={(e) => onChangeTextFeild(e, "bio")}
				/>
				<input
					type="text"
					value={linkedIn}
					placeholder="Enter your LinkedIn URL:"
					onChange={(e) => onChangeTextFeild(e, "linkedIn")}
				/>
				<input
					type="text"
					value={twitter}
					placeholder="Enter your Twitter URL:"
					onChange={(e) => onChangeTextFeild(e, "twitter")}
				/>
				<input
					type="text"
					value={github}
					placeholder="Enter Your Github URL:"
					onChange={(e) => onChangeTextFeild(e, "github")}
				/>
				<input
					type="text"
					value={website}
					placeholder="Enter your Web2 Website URL:"
					onChange={(e) => onChangeTextFeild(e, "website")}
				/>
				<input
					type="email"
					value={email}
					placeholder="Enter your email"
					onChange={(e) => onChangeTextFeild(e, "email")}
				/>
				<input
					type="text"
					value={leetcode}
					placeholder="Enter your Leetcode  URL:"
					onChange={(e) => onChangeTextFeild(e, "leetcode")}
				/>

				{editing ? (
					<div className="button-container">
						// This will call the updateDomain function we just made
						<button
							className="cta-button mint-button"
							disabled={loading}
							onClick={updateDomain}>
							Set record
						</button>
						// This will let us get out of editing mode by setting editing to
						false
						<button
							className="cta-button mint-button"
							onClick={() => {
								setEditing(false);
							}}>
							Cancel
						</button>
					</div>
				) : (
					// If editing is not true, the mint button will be returned instead
					<button
						className="cta-button mint-button"
						disabled={loading}
						onClick={mintDomain}>
						Mint
					</button>
				)}
			</div>
		);
	};
	const mintDomain = async () => {
		// Don't run if the domain is empty
		if (!domain) {
			return;
		}
		// Alert the user if the domain is too short
		if (domain.length < 3) {
			alert("Domain must be at least 3 characters long");
			return;
		}
		// Calculate price based on length of domain (change this to match your contract)
		// 3 chars = 0.5 MATIC, 4 chars = 0.3 MATIC, 5 or more = 0.1 MATIC
		const price =
			domain.length === 3 ? "0.02" : domain.length === 4 ? "0.01" : "0.01";
		console.log("Minting domain", domain, "with price", price);
		try {
			const { ethereum } = window;
			if (ethereum) {
				const provider = new ethers.providers.Web3Provider(ethereum);
				const signer = provider.getSigner();
				const contract = new ethers.Contract(
					CONTRACT_ADDRESS,
					DomainService.abi,
					signer,
				);

				console.log("Going to pop wallet now to pay gas...");
				let tx = await contract.register(domain, {
					value: ethers.utils.parseEther(price),
				});
				// Wait for the transaction to be mined
				const receipt = await tx.wait();

				// Check if the transaction was successfully completed
				if (receipt.status === 1) {
					console.log(
						"Domain minted! https://mumbai.polygonscan.com/tx/" + tx.hash,
					);

					// Set the record for the domain
					tx = await contract.setRecords(
						domain,
						bio,
						linkedIn,
						twitter,
						github,
						website,
						email,
						leetcode,
					);
					await tx.wait();

					console.log(
						"Record set! https://mumbai.polygonscan.com/tx/" + tx.hash,
					);
					setTimeout(() => {
						fetchMints();
					}, 2000);
					setBio("");
					setLinkedIn("");
					setEmail("");
					setGithub("");
					setLeetcode("");
					setTwitter("");
					setWebsite("");

					setDomain("");
				} else {
					alert("Transaction failed! Please try again");
				}
			}
		} catch (error) {
			console.log(error);
		}
	};
	const renderMints = () => {
		if (account && mints.length > 0) {
			return (
				<div className="mint-container">
					<p className="subtitle"> Recently minted domains!</p>
					<div className="mint-list">
						{mints.map((mint, index) => {
							return (
								<div className="mint-item" key={index}>
									<div className="mint-row">
										<a
											className="link"
											href={`https://testnets.opensea.io/assets/mumbai/${CONTRACT_ADDRESS}/${mint.id}`}
											target="_blank"
											rel="noopener noreferrer">
											<p className="underlined">
												{" "}
												{mint.name}
												{tld}{" "}
											</p>
										</a>
										{/* If mint.owner is currentAccount, add an "edit" button*/}
										{mint.owner.toLowerCase() === account.toLowerCase() ? (
											<button
												className="edit-button"
												onClick={() => editRecord(mint.name)}>
												<img
													className="edit-icon"
													src="https://img.icons8.com/metro/26/000000/pencil.png"
													alt="Edit button"
												/>
											</button>
										) : null}
									</div>
									<p> {mint.record} </p>
								</div>
							);
						})}
					</div>
				</div>
			);
		}
	};
	const editRecord = (name) => {
		console.log("Editing record for", name);
		setEditing(true);
		setDomain(name);
	};
	const renderNotConnectedContainer = () => (
		<div className="connect-wallet-container">
			<img
				src="https://media.giphy.com/media/RbDKaczqWovIugyJmW/giphy.gif"
				alt="Ninja gif"
			/>
			<button
				className="cta-button connect-wallet-button"
				onClick={connectWallet}>
				Connect Wallet
			</button>
		</div>
	);

	useEffect(() => {
		checkIfWalletIsConnected();
	}, []);
	useEffect(() => {
		if (network === "Polygon Mumbai Testnet") {
			fetchMints();
		}
	}, [account, network]);
	return (
		<div className="App">
			<Navbar></Navbar>
			<div className="container">
				<div className="header-container">
					<header>
						<div className="left">
							<p className="title">Coder Name Service</p>
							<p className="subtitle">Your immortal API on the blockchain!</p>
						</div>
						<div className="right">
							<img
								alt="Network logo"
								className="logo"
								src={network.includes("Polygon") ? polygonLogo : ethLogo}
							/>
							{account ? (
								<p>
									{" "}
									Wallet: {account.slice(0, 6)}...
									{account.slice(-4)}{" "}
								</p>
							) : (
								<p> Not connected </p>
							)}
						</div>
					</header>
				</div>
				{!account && renderNotConnectedContainer()}
				{account && renderInputForm()}
				{mints && renderMints()}
				<div className="footer-container">
					<img alt="Twitter Logo" className="twitter-logo" src={twitterLogo} />
					<a
						className="footer-text"
						href={TWITTER_LINK}
						target="_blank"
						rel="noreferrer">{`built with @${TWITTER_HANDLE}`}</a>
				</div>
			</div>
		</div>
	);
};

export default App;
